import React from "react";

import { Header, Title, Icon } from "./styled";

interface GroupHeaderProps {
  groupName: string;
  isGroupExpanded: boolean;
  onExpandGroup: () => void;
}

export const GroupHeader = (props: GroupHeaderProps) => {
  const ExpandArrowIcon = Icon(props.isGroupExpanded);

  return (
    <Header>
      <Title>{props.groupName}</Title>
      <ExpandArrowIcon onClick={() => props.onExpandGroup()} />
    </Header>
  );
};
